import { render } from "./ItemHistoryModal.vue?vue&type=template&id=490e7c3e&scoped=true"
import script from "./ItemHistoryModal.vue?vue&type=script&lang=js"
export * from "./ItemHistoryModal.vue?vue&type=script&lang=js"

import "./ItemHistoryModal.vue?vue&type=style&index=0&id=490e7c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490e7c3e"]])

export default __exports__